import { Box, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';

// Components
import ExpandableBox from 'src/components/common/ExpandableBox';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import TableHorizontal from 'src/components/TableHorizontal';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

// Utilities

const Port = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();

  const configColumn = [
    {
      label: 'Export Port ',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.transaction?.export_port),
      renderCell: (data: IBillOfLadingDetail) =>
        data?.export_port?.mapped_econ ? (
          <RouterLinkNoUnderline to={AuthRouteKeys.PortDetail.replace(':id?', data?.export_port?.id || '')}>
            <Typography variant="body2" color={'secondary'}>
              {renderTextOrDefault(data?.export_port?.port_name)}
            </Typography>
          </RouterLinkNoUnderline>
        ) : (
          <Typography color={'text.secondary'} variant="body2">
            {renderTextOrDefault(data?.transaction?.export_port)}
          </Typography>
        ),
    },
    {
      label: 'Import Port ',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.transaction?.import_port),
      renderCell: (data: IBillOfLadingDetail) =>
        data?.import_port?.mapped_econ ? (
          <RouterLinkNoUnderline to={AuthRouteKeys.PortDetail.replace(':id?', data?.import_port?.id || '')}>
            <Typography variant="body2" color={'secondary'}>
              {renderTextOrDefault(data?.import_port?.port_name)}
            </Typography>
          </RouterLinkNoUnderline>
        ) : (
          <Typography color={'text.secondary'} variant="body2">
            {renderTextOrDefault(data?.transaction?.import_port)}
          </Typography>
        ),
    },
  ];

  return (
    <ExpandableBox title="Port" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <TableHorizontal colKeyWidth={350} configColumn={configColumn} data={tradeDataDetail} />
      </Box>
    </ExpandableBox>
  );
};

export default Port;
